/**
 * CONNECTIONS PUZZLE DATA
 *
 * How to customize this puzzle:
 * 1. Edit the 4 groups below with your own shared memories
 * 2. Each group needs exactly 4 items
 * 3. Change the 'category' to describe what connects the 4 items
 * 4. Difficulty levels: 'easy', 'medium', 'hard', 'tricky' (affects color coding)
 *
 * Example categories for your relationship:
 * - Places you've visited together
 * - Inside jokes or phrases
 * - Restaurants you love
 * - Movies/shows you watched
 * - Activities you've done
 * - Pet names or nicknames
 */

export const connectionsGroups = [
  {
    id: 1,
    category: "PLACES WE'VE WATCHED GAMES",
    items: ["LEVIS STADIUM", "CHASE CENTER", "ORACLE PARK", "DODGER STADIUM"],
    difficulty: "easy",
  },
  {
    id: 2,
    category: "TRIPS WE'VE TAKEN TOGETHER",
    items: ["VEGAS", "CANCUN", "PASO ROBLES", "PITTSBURGH"],
    difficulty: "medium",
  },
  {
    id: 3,
    category: "OUR FIRST TRIP TOGETHER",
    items: ["SNORKELLING", "PARASAILING", "ALL INCLUSIVE", "HURRICANE"],
    difficulty: "hard",
  },
  {
    id: 4,
    category: "FIRST DATE",
    items: ["ACAI BOWLS", "MANRESA BEACH", "APTOS", "JUICY SWEET"],
    difficulty: "tricky",
  },
];

// Helper function to shuffle array
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Create shuffled list of all items for initial display
const allItems = connectionsGroups.flatMap((group) => group.items);
export const shuffledItems = shuffleArray(allItems);
